import React, { useEffect, useRef, useState } from 'react';
import { ArrowDownIcon, ArrowUpIcon, Button } from 'glints-aries';
import { FormattedMessage } from 'react-intl';

import { DraftjsReader } from 'src/components/Editor/DraftjsReader';
import * as S from 'src/modules/Opportunity/Components/JobDescription.sc';

export const JobInterviewProcess: React.FC<
  React.PropsWithChildren<{
    interviewProcessJsonString: string;
  }>
> = ({ interviewProcessJsonString }) => {
  const ref = useRef(null);

  const [isReadMore, setIsReadMore] = useState<boolean>(true);
  const [shouldShowReadMore, setShouldShowReadMore] = useState<boolean>(false);

  useEffect(
    function handleJobDescriptionReadMore() {
      if (ref.current && ref.current.clientHeight > 100) {
        setShouldShowReadMore(true);
      }
    },
    [setShouldShowReadMore, ref]
  );

  if (!interviewProcessJsonString) {
    return null;
  }

  const interviewProcess = JSON.parse(interviewProcessJsonString);

  return (
    <>
      <S.TitleContainer>
        <FormattedMessage
          id="job-detail_section-title_interview-process"
          defaultMessage="Interview Process"
          tagName={S.Title}
        />
      </S.TitleContainer>
      <S.DescriptionContainer
        shouldShowReadMore={shouldShowReadMore && isReadMore}
        ref={ref}
      >
        <DraftjsReader draftjsObject={interviewProcess} />
      </S.DescriptionContainer>
      <If condition={shouldShowReadMore}>
        {isReadMore ? (
          <S.ReadButton>
            <Button
              variant="link"
              onClick={() => setIsReadMore(false)}
              endIcon={<ArrowDownIcon width="12px" height="12px" />}
            >
              <FormattedMessage
                id="job_detail_page.company_section.read_more"
                defaultMessage="Read More"
              />
            </Button>
          </S.ReadButton>
        ) : (
          <S.ReadButton>
            <Button
              variant="link"
              onClick={() => setIsReadMore(true)}
              endIcon={<ArrowUpIcon width="12px" height="12px" />}
            >
              <FormattedMessage
                id="job_detail_page.company_section.read_less"
                defaultMessage="Read Less"
              />
            </Button>
          </S.ReadButton>
        )}
      </If>
    </>
  );
};
